import buildResourceActions from 'store/configure/actions';

const resourceActions = buildResourceActions('sharedPhotosV2');

export default resourceActions;
